export default __webpack_public_path__ + "static/media/slide1.5977a17d.jpg";